const routes = {
  suppliers: 'Flotte'
};

export default routes;